import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Claim } from '../../../generic/classes/claim';
import { ClaimResponse } from '../../../generic/classes/claim.response';
import { ConfigurationHelper } from '../../../generic/helper/configuration.helper';
import { Logger } from '../../../generic/logging/default-log.service';
import { ApplicationService } from '../../../generic/service/application.service';
import { ProductService } from '../../../generic/service/product.service';
import { ClaimService } from '../../../service/claim.service';
import { NumberFormatPipe } from '../../../generic/pipes/number.format.pipe';
import { CustomDatePipe } from '../../../generic/pipes/custom.date.pipe';
import { RenderProductImageComponent } from '../../../generic/component/products/render.product.image';
import { RenderClaimStatusComponent } from './render.claim.status';

const TYPE_PRODUCT_QUALITY = 'PDKWLT';

@Component({
    selector: 'claim-detail',
    templateUrl: 'claim.detail.component.html',
    styleUrls: ['./claim.component.scss'],
    standalone: true,
    imports: [
        RouterLink,
        RenderClaimStatusComponent,
        RenderProductImageComponent,
        CustomDatePipe,
        NumberFormatPipe,
    ],
})
export class ClaimDetailComponent implements OnInit {
    claim: Claim;
    claimId: string;
    images: string[];

    constructor(
        public applicationService: ApplicationService,
        private productService: ProductService,
        private activatedRoute: ActivatedRoute,
        private claimService: ClaimService,
        private logger: Logger,
    ) {}

    ngOnInit() {
        this.activatedRoute.params.subscribe(params => {
            this.claimId = params.claimId;
            this.getClaim(this.claimId);
        });
    }

    getClaim(claimId: string): void {
        this.claimService.getClaim(claimId).subscribe({
            next: response => this.setClaimInformation(response),
            error: error => this.logger.error('Failed to get claims', error),
        });
    }

    getImage(image: string): string {
        return this.productService.getImage(image);
    }

    getImageForClaimUrl(image: string): string {
        // Image is in the format prefix(in our case 'claimId')/imageName. For instance: "RE00000044/ARDISIA%20PIKO%20CC.JPG"
        return ConfigurationHelper.getWebshopUrl(
            `/rest/claims/images/${image}`,
        );
    }

    openImageInPopup(image: string): void {
        const imageUrl = this.getImageForClaimUrl(image);
        window.open(imageUrl, 'image', 'width=800px,height=800px');
    }

    claimHasImages(): boolean {
        return (
            this.claim.category === TYPE_PRODUCT_QUALITY &&
            this.images.length > 0
        );
    }

    getDetails(): string | null {
        if (
            this.claim.categoryDescription === null &&
            this.claim.codeDescription === null
        ) {
            return null;
        }
        return `${this.claim.categoryDescription}: ${this.claim.codeDescription}`;
    }

    private setClaimInformation(claimResponse: ClaimResponse) {
        this.claim = claimResponse.claim;
        this.images = claimResponse.imagesForClaim;
    }
}
